import { RVEditableFormItemPanelHeader } from "Components/elements/RVCollapse/Shared/Components/RVEditableFormItemPanelHeader/RVEditableFormItemPanelHeader";

import type { FormInstance } from "antd";

type CommonPanelProps = {
    form: FormInstance;
    index: number;
    remove: (index?: number) => void;
    id: string;
};

type BaseContentProps<T> = {
    form: FormInstance;
    id: string;
    index: number;
} & T;

export type GenerateTriggerEventPropertyCollapsePanelProps<T> = CommonPanelProps & {
    contentComponent: React.ComponentType<BaseContentProps<T>>;
    contentProps: T;
};

// FORM PANEL CREATION
const PROPERTY_HEADER = "Property";
export function generateTriggerEventProperty<T>({
    form,
    index,
    remove,
    id,
    contentComponent: ContentComponent,
    contentProps,
}: GenerateTriggerEventPropertyCollapsePanelProps<T>) {
    return {
        id,
        forceRender: true,
        header: (
            <RVEditableFormItemPanelHeader
                panelIndex={index}
                key={id}
                form={form}
                remove={() => remove(index)}
                name={PROPERTY_HEADER}
                disabled
            />
        ),
        content: <ContentComponent {...contentProps} form={form} id={id} index={index} />,
    };
}

const PROFILE_HEADER = "Contact Attribute";
export function generateUpdateProfileCollapsePanel<T>({
    form,
    index,
    remove,
    id,
    contentComponent: ContentComponent,
    contentProps,
}: GenerateTriggerEventPropertyCollapsePanelProps<T>) {
    return {
        id,
        forceRender: true,
        header: (
            <RVEditableFormItemPanelHeader
                panelIndex={index}
                key={id}
                form={form}
                remove={() => remove(index)}
                name={PROFILE_HEADER}
                disabled
            />
        ),
        content: <ContentComponent key={id} {...contentProps} form={form} id={id} index={index} />,
    };
}

// DATA MAPPING HELPERS
export const extractFormFieldName = (field: any) => {
    return typeof field.name === "string" ? field.name : field.name[0];
};
